import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import Searchbar from './components/Searchbar';
import pictureLogo from '../../../images/logo.png';
import pictureShortLogo from '../../../images/logo_symbole.png'

import NavbarConnect from "./components/NavbarConnect";
import SubNavbar from "./components/SubNavbar";
import {useBreakpoint} from "../../../libs/breakpoint";

const NavBar = ({
                    token,
                    authenticated = false,
                    currentUserInitialized = false,
                    ...props
                }) => {
    const [toggleSearchBar, setToggleSearchBar] = useState(false);
    const breakpoints = useBreakpoint();
    let isMobile = !!breakpoints.md;

    return (
        <header>
            <div className="navbar-header-wrapper">
                <div className="container navbar-header">
                    <h1 className="logo-navbar">
                        <Link to="/" title={"Voissa"} rel="nofollow noopener noreferrer" >
                            <img src={isMobile ? pictureShortLogo : pictureLogo} alt="Voissa"/>
                        </Link>
                    </h1>
                    <Searchbar className={!authenticated ? 'not-logged' : ''}
                       handleSearchBarDisplay={setToggleSearchBar}
                       history={props.history}
                       location={props.location}
                       currentUserInitialized={currentUserInitialized}
                    />
                    <NavbarConnect
                        token={token}
                        showSearchBar={toggleSearchBar}/>
                </div>
            </div>
            <SubNavbar
                currentUserInitialized={currentUserInitialized}
            />
        </header>
    );
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
